export default "<template>\r\n  <v-btn block color=\"secondary\" dark>Block Button</v-btn>\r\n</template>\r\n";